module.exports = __webpack_public_path__ + "img/Kibe24.63044d3b.jpg";